<template>
  <div class="col contact-info new-contacts-details">
    <div class="expand-icon" @click="goDetail(contactObj)" v-if="isList">
      <span class="material-icons-outlined">keyboard_double_arrow_left</span>
      Expandir
    </div>
    <button class="btn close" @click="
      $root.$emit('bv::toggle::collapse', 'contact-sidebar-detail'), (contactObj = null)
      " v-if="isList">
      <span class="material-icons-outlined">close</span>
    </button>
    <div class="contents">
      <div v-if="isList">
        <figure v-if="contactObj.profile_picture == null">
          <div class="fallback-image">
            {{ initials(contactObj.first_name, contactObj.last_name) }}
          </div>
        </figure>
        <div class="img-preview" :class="{ hide: contactObj.profile_picture == null }"
          :style="`background: url(${contactObj.profile_picture})`"></div>
        <h4>
          {{ contactObj.first_name }}
          {{ contactObj.last_name }}
        </h4>
      </div>
      <div class="channels" v-if="isList">
        <ul class="list-unstyled">
          <li>
            <div class="control-group opt-2">
              <span v-tooltip.right="$t('contacts-component.send.message')" @click="goToSend('SmsSend')">
                <img src="assets/img/icons/svg/SMS.svg" class="c-pointer" />
              </span>
            </div>
          </li>
          <li>
            <div class="control-group opt-2">
              <span to="/whatsapp/send" v-tooltip.right="'Enviar WhatsApp'" @click="goToSend('WhatsAppSend')">
                <img src="assets/img/icons/svg/Whatsapp.svg" class="c-pointer" />
              </span>
            </div>
          </li>
          <li>
            <div class="control-group opt-2">
              <span to="/email/send" v-tooltip.right="'Enviar Email'" @click="goToSend('MailSend')">
                <img src="assets/img/icons/svg/email.svg" class="c-pointer" />
              </span>
            </div>
          </li>
          <li>
            <div class="control-group opt-2">
              <span to="/rcs/send" v-tooltip.right="'Enviar RCS'" @click="goToSend('RCSSend')">
                <img src="assets/img/icons/svg/RCS.svg" class="c-pointer" />
              </span>
            </div>
          </li>
        </ul>
      </div>
      <template v-if="isLoading">
        <div class="loading-container">
          <b-spinner class="spinner-color" label="Spinning"></b-spinner>
        </div>
      </template>
      <template v-else>
        <div class="details" v-if="checkObject(formContact)">
          <scrollbar id="contentScroll" role="tablist" class="scrollbar-data" ref="scrollbarData">
            <template v-if="savingContact">
              <div class="qt-block-ui relative"></div>
            </template>
            <template v-else-if="editingContactAttr">
              <h5 class="pb-0">{{ $t("contact-list-component.register.infos") }}</h5>
              <label class="md-3">
                <span class="form-label">{{ $tc("app.name", 1) }}*</span>
                <input class="form-control" type="text" :placeholder="$t('generic-str.lbl-first-name')"
                  v-model="formContact.first_name" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.lbl-last-name") }}</span>
                <input class="form-control" type="text" :placeholder="$t('generic-str.lbl-last-name')"
                  v-model="formContact.last_name" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.email") }}*</span>
                <input class="form-control" type="email" placeholder="example@email.com" v-model="formContact.email" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.lbl-cellphone") }}*</span>
                <tel-input ref="mobile_number" required v-model="formContact.mobile_number" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $tc("generic-str.tel", 1) }}</span>
                <tel-input ref="phone" v-model="formContact.phone" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("properties.company") }}</span>
                <input class="form-control" type="text" placeholder="Ex: Yup Chat" v-model="formContact.company" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.gender") }}</span>
                <select-input label="text" :reduce="(gender) => gender.value" v-model="formContact.gender"
                  :options="genders" :clearable="false" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.group") }}</span>
                <select-input multiple label="name" :reduce="(group) => group.id" v-model="formContact.groups"
                  :options="groupList" :clearable="false" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.birthdate") }}</span>
                <input class="form-control" placeholder="" type="date" v-model="formContact.birthdate" />
              </label>

              <hr />
              <div class="custom-field-wrapper">
                <span class="d-flex align-items-center field-title">
                  <span class="material-symbols-outlined mr-1">playlist_add</span>
                  {{ $t("contacts-component.custom-field") }}
                </span>
                <!-- <code>Amount of customFields: {{ customFields.length }}</code> -->
                <button v-if="!customFields && customFields.length === 0" v-b-toggle.create-custom-field-sidebar
                  class="btn btn-add-card">
                  {{ $t("app.add-new") }}
                  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5"
                    stroke="currentColor" class="heroicon add">
                    <path stroke-linecap="round" stroke-linejoin="round"
                      d="M12 9v6m3-3H9m12 0a9 9 0 11-18 0 9 9 0 0118 0z" />
                  </svg>
                </button>
                <template>
                  <label v-for="(customField, index) in formContact.fill_custom_fields" :key="index" class="md-3">
                    <span class="form-label">
                      {{ customField.custom_field.name }}
                      {{ customField.custom_field.required_field ? "*" : "" }}
                    </span>
                    <input class="form-control" type="text" @input="
                      handleEditSelectCustomField(
                        customField.id,
                        customField.value,
                        true
                      )
                      " :required="customField.custom_field.required_field" :placeholder="customField.value ? customField.value : 'Campo customizado'
                        " :ref="`customField-${index}`" v-model="customField.value" />
                  </label>
                </template>
                <template v-if="customFieldsToBeAdded.length > 0">
                  <div class="custom-field-suggestion">
                    <label v-for="(customField, index) in customFieldsToBeAdded" :key="customField.id" class="md-3"
                      @click="inputActive" :class="{
                        filled: customField.value,
                        empty: !customField.value,
                      }">
                      <span class="form-label">{{ customField.name }}</span>
                      <input class="form-control" type="text" :placeholder="customField.value ? customField.value : 'Campo customizado'
                        " :ref="`customField-${index}`" v-model="customField.value" />
                    </label>
                  </div>
                </template>
              </div>
              <!-- <code>Amount of customFields: {{customFields.length}}</code> -->
              <hr />
              <h5 class="icon-title">
                <span class="material-symbols-outlined fill-icon">home</span>{{ $t("app.address") }}
              </h5>
              <label class="md-3">
                <span class="form-label">CEP</span>
                <input v-on:keyup="checkZipCode(formContact.zip)" class="form-control" v-zip type="text"
                  placeholder="77555-000" pattern="\w{9}" maxlength="9" v-model="formContact.zip" />
              </label>
              <label class="md-3">
                <label class="form-label">{{ $t("generic-str.state") }}</label>
                <select v-model="formContact.state" type="text" class="form-control">
                  <option value="AC">Acre</option>
                  <option value="AL">Alagoas</option>
                  <option value="AP">Amapá</option>
                  <option value="AM">Amazonas</option>
                  <option value="BA">Bahia</option>
                  <option value="CE">Ceará</option>
                  <option value="DF">Distrito Federal</option>
                  <option value="ES">Espírito Santo</option>
                  <option value="GO">Goiás</option>
                  <option value="MA">Maranhão</option>
                  <option value="MT">Mato Grosso</option>
                  <option value="MS">Mato Grosso do Sul</option>
                  <option value="MG">Minas Gerais</option>
                  <option value="PA">Pará</option>
                  <option value="PB">Paraíba</option>
                  <option value="PR">Paraná</option>
                  <option value="PE">Pernambuco</option>
                  <option value="PI">Piauí</option>
                  <option value="RJ">Rio de Janeiro</option>
                  <option value="RN">Rio Grande do Norte</option>
                  <option value="RS">Rio Grande do Sul</option>
                  <option value="RO">Rondônia</option>
                  <option value="RR">Roraima</option>
                  <option value="SC">Santa Catarina</option>
                  <option value="SP">São Paulo</option>
                  <option value="SE">Sergipe</option>
                  <option value="TO">Tocantins</option>
                  <option value="EX">Estrangeiro</option>
                </select>
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.city") }}</span>
                <input class="form-control" type="text" placeholder="Ex: Peruíbe" v-model="formContact.city" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("app.address") }}</span>
                <input class="form-control" type="text" placeholder="Ex: Av Guimarães Rosa"
                  v-model="formContact.address" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.neighborhood") }}</span>
                <input class="form-control" type="text" placeholder="Ex: Av Guimarães Rosa"
                  v-model="formContact.district" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $tc("generic-str.lbl-number", 1) }}</span>
                <input class="form-control" type="text" placeholder="Ex: 1000" v-model="formContact.number" />
              </label>

              <label class="md-3">
                <span class="form-label">{{ $t("generic-str.complement") }}</span>
                <input class="form-control" type="text" placeholder="Ex: apt 201" v-model="formContact.complement" />
              </label>

              <hr />

              <h5>
                <span class="material-symbols-outlined fill-icon">share</span>Social
              </h5>

              <label class="md-3">
                <span class="form-label">Website</span>
                <input class="form-control" type="text" placeholder="https://" v-model="formContact.website" />
              </label>

              <label class="md-3">
                <span class="form-label">Facebook</span>
                <input class="form-control" type="text" placeholder="https://" v-model="formContact.facebook" />
              </label>

              <label class="md-3">
                <span class="form-label">Instagram</span>
                <input class="form-control" type="text" placeholder="https://" v-model="formContact.instagram" />
              </label>

              <label class="md-3">
                <span class="form-label">Twitter</span>
                <input class="form-control" type="text" placeholder="https://" v-model="formContact.twitter" />
              </label>

              <label class="md-3">
                <span class="form-label">Linkedin</span>
                <input class="form-control" type="text" placeholder="https://" v-model="formContact.linkedin" />
              </label>

              <hr />

              <h5>
                <span class="material-symbols-outlined">description</span>
                {{ $t("contacts-component.description") }}
              </h5>

              <label class="md-3">
                <span class="form-label">{{ $t("app.description") }}</span>
                <textarea class="form-control" v-model="formContact.description"
                  :placeholder="$t('contacts-component.add-description')"></textarea>
              </label>

              <hr />

              <div class="save d-flex justify-content-between">
                <div></div>
                <div class="d-flex justify-content-between">
                  <button class="btn btn-outline-primary" @click="edit()">
                    {{ $t("app.cancel") }}
                  </button>
                  <button id="saveBtn" class="btn btn-primary" :disabled="!isDifferent" @click="saveContactMixin">
                    {{ $t("app.save") }}
                  </button>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="d-flex justify-content-between mb-3">
                <h5 class="pb-0">
                  {{ $t("contact-list-component.register.infos") }}
                </h5>
                <!-- <button class="edit" @click="showContactModal(currentContact, 'contact-modal')"> -->
                <button class="btn edit mr-2" @click="edit()">
                  <span class="material-symbols-outlined thin-icon">edit</span>
                </button>
              </div>

              <ul>
                <li v-if="formContact.company">
                  <div class="icn">
                    <span class="material-icons-outlined">business</span>
                  </div>
                  <div class="item">
                    {{
                      formContact.company
                        ? formContact.company
                        : $t("contact-list-component.user.job-not-found")
                    }}
                  </div>
                </li>
                <li v-if="formContact.gender">
                  <div class="icn">
                    <span class="material-icons-outlined">transgender</span>
                  </div>
                  <div class="item">
                    {{
                      formContact.gender
                        ? formContact.gender
                        : $t("contact-list-component.user.gen-not-found")
                    }}
                  </div>
                </li>
                <li v-if="formContact.birthdate">
                  <div class="icn">
                    <span class="material-icons-outlined">calendar_today</span>
                  </div>
                  <div class="item">
                    <!-- {{ formatDate(formContact.birthdate)}} -->
                    {{ formContact.birthdate | formatDate }}
                  </div>
                </li>
                <li v-if="formContact.website">
                  <div class="icn">
                    <span class="material-icons-outlined">language</span>
                  </div>
                  <div class="item">
                    <a :href="normalizeUrl(formContact.website)" target="_blank" rel="noopener noreferrer"
                      class="text-primary">
                      {{ formContact.website }}
                    </a>
                  </div>
                </li>
                <li v-if="formContact.email">
                  <div class="icn">
                    <span class="material-icons-outlined">email</span>
                  </div>
                  <div class="item">
                    {{
                      formContact.email
                        ? formContact.email
                        : $t("contact-list-component.user.email-not-found")
                    }}
                  </div>
                </li>
                <li v-if="formContact.mobile_number">
                  <div class="icn">
                    <span class="material-icons-outlined">phone</span>
                  </div>
                  <div class="item" v-if="formContact.mobile_number">
                    {{ formContact.mobile_number | maskPhone }}
                  </div>
                  <div class="item" v-else>
                    {{ $t("contact-list-component.user.number-not-found") }}
                  </div>
                </li>
                <li v-if="formContact.phone">
                  <div class="icn">
                    <span class="material-icons-outlined">phone</span>
                  </div>
                  <div class="item" v-if="formContact.phone">
                    {{ formContact.phone | maskPhone }}
                  </div>
                  <div class="item" v-else>
                    {{ $t("contact-list-component.user.number-not-found") }}
                  </div>
                </li>
                <li v-if="formContact.facebook">
                  <div class="icn">
                    <figure>
                      <img src="@/assets/icons/social/facebook.png" />
                    </figure>
                  </div>
                  <div class="item">
                    <a :href="formContact.facebook" target="_blank">@{{ matchedString.facebook }}</a>
                  </div>
                </li>
                <li v-if="formContact.instagram">
                  <div class="icn">
                    <figure>
                      <img src="@/assets/icons/social/instagram.png" />
                    </figure>
                  </div>
                  <div class="item">
                    <a :href="formContact.instagram" target="_blank">@{{ matchedString.instagram }}</a>
                  </div>
                </li>
                <li v-if="formContact.twitter">
                  <div class="icn">
                    <figure>
                      <img src="@/assets/icons/social/twitter.png" />
                    </figure>
                  </div>
                  <div class="item">
                    <a :href="formContact.twitter" target="_blank">@{{ matchedString.twitter }}</a>
                  </div>
                </li>
                <li v-if="formContact.linkedin">
                  <div class="icn">
                    <figure>
                      <img src="@/assets/icons/social/linkedin.png" />
                    </figure>
                  </div>
                  <div class="item">
                    <a :href="formContact.linkedin" target="_blank">@{{ matchedString.linkedin }}</a>
                  </div>
                </li>
                <li v-if="formContact.address">
                  <div class="icn">
                    <span class="material-icons-outlined">location_on</span>
                  </div>
                  <div class="item" v-if="formContact.address">
                    {{ formContact.address ? formContact.address : ""
                    }}{{ formContact.number ? `, nº ${formContact.number}` : ""
                    }}{{ formContact.complement ? `, ${formContact.complement}` : ""
                    }}{{ formContact.district ? `, ${formContact.district}` : ""
                    }}{{
                      formContact.zip
                        ? `. ${$t("generic-str.zipcode")}: ${formContact.zip}`
                        : ""
                    }}{{ formContact.state ? `, ${formContact.state}` : "" }}
                  </div>
                </li>
                <li class="pb-0" v-if="(formContact.fill_custom_fields || []).length !== 0">
                  {{ $t("contacts-component.custom-field") }}
                </li>
                <template v-if="(formContact.fill_custom_fields || []).length !== 0">
                  <li v-for="(innerField, index) in formContact.fill_custom_fields" :key="index" :class="`custom-field field-${innerField.value
                    .replace(/ /g, '-')
                    .toLowerCase()} pt-0`">
                    <div class="icn">
                      <span class="material-symbols-outlined">rate_review</span>
                    </div>
                    <div class="item">
                      <b>{{ innerField.custom_field.name }}: </b>
                      {{
                        innerField.custom_field.sensitive_content === true
                          ? `${innerField.value.substring(0, 3)}...`
                          : innerField.value
                      }}
                    </div>
                  </li>
                </template>
              </ul>

              <!-- <div class="humor">
              <div class="d-flex note">
                <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path
                    d="M20 39.143C10.3793 39.143 0 33.1085 0 19.8672C0 6.62579 10.3793 0.591309 20 0.591309C25.3448 0.591309 30.2759 2.34993 33.931 5.55683C37.8966 9.07407 40 14.0396 40 19.8672C40 25.6948 37.8966 30.6258 33.931 34.143C30.2759 37.3499 25.3103 39.143 20 39.143Z"
                    fill="url(#paint0_radial_439_8517)" />
                  <path
                    d="M36.5138 8.40869C38.3517 11.3742 39.3103 14.9052 39.3103 18.8328C39.3103 24.6604 37.2069 29.5915 33.2414 33.1087C29.5862 36.3156 24.6207 38.1087 19.3103 38.1087C13.0827 38.1087 6.55171 35.5742 2.69653 30.1983C6.40688 36.288 13.3862 39.1432 20 39.1432C25.3103 39.1432 30.2758 37.3501 33.931 34.1432C37.8965 30.6259 40 25.6949 40 19.8673C40 15.4742 38.8034 11.5708 36.5138 8.40869Z"
                    fill="#EB8F00" />
                  <path
                    d="M20.2758 26.9015C19.0413 26.9015 17.8172 26.6946 16.6551 26.2808C15.2241 25.7877 13.6689 26.5498 13.1758 27.9773C12.8965 28.7842 13.0103 29.6739 13.4827 30.3842C14.9655 32.6601 17.3103 33.9015 20.2758 33.9015C23.2413 33.9015 25.5862 32.6601 27.0689 30.3842C27.9069 29.1256 27.562 27.4256 26.3034 26.5877C25.5931 26.1153 24.7034 26.0015 23.8965 26.2808C22.7344 26.6946 21.5103 26.9015 20.2758 26.9015Z"
                    fill="#422B0D" />
                  <path opacity="0.8"
                    d="M9.86212 28.9364C13.1949 28.9364 15.8966 26.3891 15.8966 23.2468C15.8966 20.1045 13.1949 17.5571 9.86212 17.5571C6.52937 17.5571 3.82764 20.1045 3.82764 23.2468C3.82764 26.3891 6.52937 28.9364 9.86212 28.9364Z"
                    fill="url(#paint1_radial_439_8517)" />
                  <path opacity="0.8"
                    d="M30.6896 28.9364C34.0224 28.9364 36.7241 26.3891 36.7241 23.2468C36.7241 20.1045 34.0224 17.5571 30.6896 17.5571C27.3569 17.5571 24.6552 20.1045 24.6552 23.2468C24.6552 26.3891 27.3569 28.9364 30.6896 28.9364Z"
                    fill="url(#paint2_radial_439_8517)" />
                  <path
                    d="M35.1689 10.0294C32.3379 9.23284 30.2586 11.5466 30.2586 11.5466C30.2586 11.5466 30.0172 8.92249 27.5965 8.09836C24.693 7.1018 21.6275 8.68801 21.4448 12.8018C21.2379 17.488 27.4379 23.6397 27.4379 23.6397C27.4379 23.6397 35.1344 21.5708 37.6551 17.1846C39.7068 13.6156 37.3103 10.6294 35.1689 10.0294Z"
                    fill="#F44336" />
                  <path
                    d="M35.1689 10.0292C34.8207 9.9361 34.462 9.89472 34.1034 9.90162C35.1172 10.5809 35.9207 11.5292 36.4207 12.6395C36.9069 13.8085 37.0345 15.3189 36.1103 17.1223C34.1069 21.043 27.9379 23.4706 27.4896 23.6395C28.0517 23.4809 35.2448 21.412 37.6689 17.1947C39.7069 13.6154 37.3103 10.6292 35.1689 10.0292Z"
                    fill="#C62828" />
                  <path
                    d="M30.2552 11.9706C30.2345 11.612 30.1793 11.2534 30.0965 10.9016C29.8965 9.88784 29.269 9.00853 28.3724 8.48784C27.7586 8.12922 27.0793 7.90164 26.3759 7.81543C26.3759 7.81543 27.4103 8.12922 28.1483 9.56026C28.5241 10.312 28.7483 11.1327 28.8034 11.9706C28.8 12.2775 28.8552 12.5775 28.9655 12.8637C29.0896 13.1499 29.3931 13.3189 29.7034 13.2706C30.1759 13.1499 30.2793 12.5603 30.2552 11.9706Z"
                    fill="#C62828" />
                  <path
                    d="M23.5517 10.3256C24.1966 9.52564 25.2552 8.76357 26.269 9.46702C26.8069 9.84288 26.8138 10.9084 26.1552 11.3877C25.0448 12.2015 24.9931 12.736 24.869 13.1843C24.7173 13.7187 24.6207 14.3567 24.1345 14.6256C23.6483 14.8946 23.2207 14.6256 22.9655 13.8567C22.531 12.6567 22.7517 11.3187 23.5517 10.3256Z"
                    fill="#FF847A" />
                  <path
                    d="M12.1103 8.02937C9.31372 8.93627 8.86545 12.0156 8.86545 12.0156C8.86545 12.0156 7.21028 9.94661 4.72752 10.6156C1.76545 11.3949 0.0930344 14.4156 2.20683 17.9363C4.6551 21.9708 13.2206 23.6432 13.2206 23.6432C13.2206 23.6432 18.4792 17.657 18.1482 12.6087C17.8758 8.49834 14.2241 7.34317 12.1103 8.02937Z"
                    fill="#F44336" />
                  <path
                    d="M12.1103 8.02939C11.7689 8.13974 11.4414 8.29836 11.1414 8.49836C12.362 8.50181 13.5552 8.84663 14.5896 9.49491C15.6448 10.1846 16.5862 11.3846 16.8207 13.4018C17.3276 17.7777 13.5345 23.2156 13.2414 23.6122C13.6241 23.1708 18.462 17.4604 18.1448 12.6053C17.8758 8.49836 14.2241 7.34318 12.1103 8.02939Z"
                    fill="#C62828" />
                  <path
                    d="M9.10342 12.3776C8.88963 12.0845 8.64825 11.8155 8.37928 11.5741C7.65515 10.8362 6.6517 10.4431 5.62066 10.4983C4.91377 10.5397 4.22066 10.7224 3.58618 11.0431C3.58618 11.0431 4.62066 10.7293 6.02756 11.5155C6.76204 11.9397 7.39998 12.5086 7.91032 13.1845C8.07584 13.4431 8.28963 13.6638 8.54135 13.8397C8.80342 14.0086 9.14825 13.9776 9.37928 13.7672C9.68618 13.3948 9.44825 12.85 9.10342 12.3776Z"
                    fill="#C62828" />
                  <path
                    d="M2.6207 14.7292C2.63449 14.4395 2.68621 14.1533 2.77242 13.8775C2.9138 13.2982 3.32414 12.8188 3.87242 12.5878C4.40001 12.4223 5.13104 12.5395 5.4138 13.0671C5.66552 13.5361 5.48276 14.1016 5.34483 14.6188C5.2207 15.212 5.15173 15.8188 5.13794 16.4257C5.14139 16.9223 4.74483 17.3257 4.24828 17.3326C3.77932 17.3326 3.4138 16.9257 3.15173 16.5361C2.78621 16.0051 2.60001 15.374 2.6207 14.7292Z"
                    fill="#FF847A" />
                  <defs>
                    <radialGradient id="paint0_radial_439_8517" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(20 19.8672) scale(19.6413)">
                      <stop offset="0.5" stop-color="#FDE030" />
                      <stop offset="0.92" stop-color="#F7C02B" />
                      <stop offset="1" stop-color="#F4A223" />
                    </radialGradient>
                    <radialGradient id="paint1_radial_439_8517" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(9.86212 20.6297) scale(6.57651 5.90544)">
                      <stop stop-color="#ED7770" />
                      <stop offset="0.9" stop-color="#ED7770" stop-opacity="0" />
                    </radialGradient>
                    <radialGradient id="paint2_radial_439_8517" cx="0" cy="0" r="1" gradientUnits="userSpaceOnUse"
                      gradientTransform="translate(40.5241 869.761) scale(6.71034)">
                      <stop stop-color="#ED7770" />
                      <stop offset="0.9" stop-color="#ED7770" stop-opacity="0" />
                    </radialGradient>
                  </defs>
                </svg>
                <div>9.5</div>
              </div>
              <p>Humor geral neste trimestre</p>
            </div> -->

              <div class="description">
                <h5>{{ $t("app.description") }}</h5>
                <div :class="{ nodata: !formContact.description }">
                  <template v-if="formContact.description">
                    <div v-html="linkify(formContact.description)"></div>
                  </template>
                  <template v-else>
                    {{ $t("contacts-component.no-description") }}
                  </template>
                </div>
              </div>

              <!-- <div class="extra-info">
              <h5>Informação complementar</h5>
              <div class="item">
                <div>Ultima ação: Canal SMS</div>
                <div>
                  <span class="material-icons-outlined">sync</span>
                  22/06/2023 - 14:30
                </div>
              </div>
              <div class="item">
                <div>Tipo da ação: Campanha</div>
              </div>
              <div class="item">
                <div>Ação agendada: Canal WhatsApp</div>
                <div>
                  <span class="material-icons-outlined">sync</span>
                  22/06/2023 - 14:30
                </div>
              </div>
            </div> -->
            </template>
          </scrollbar>
          <create-custom-field-sidebar id="create-custom-field-sidebar"
            :title="$t('contact-list-component.custom-field.create')" :customFields="customFields"
            @created="fetchCustomFields()" />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import 'bootstrap-vue/dist/bootstrap-vue.css';
import axios from '@/plugins/axios';
import ContactService from '@/services/contact.service';
import SelectInput from '@/components/SelectInput.vue';
import TelInput from '@/components/form/TelInput.vue';
import CreateCustomFieldSidebar from '@/components/rebranding/contacts/CreateCustomFieldSidebar.vue';
import moment from 'moment-timezone';

// Import mixins contact
import ContactMixin from '@/mixins/ContactMixin';

const webApi = axios();

export default {
  name: 'ContactDetails',
  props: {
    contactObj: {
      type: Object,
      required: true,
      default: () => { },
    },
    isList: {
      type: Boolean,
      default: false,
    },
    isLive: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    SelectInput,
    TelInput,
    CreateCustomFieldSidebar,
  },
  mixins: [ContactMixin],
  data() {
    return {
      fetched: false,
      savingContact: false,
      liveFileIndex: null,
      isLoading: false,
    };
  },
  created() {
    this.$root.$on('contact.loadContactData', this.loadContactData);
  },
  beforeDestroy() {
    this.$root.$off('contact.loadContactData', this.loadContactData);
  },
  mounted() {
    console.log('View Contact', this);
  },
  computed: {
    matchedString() {
      const social = {
        facebook: '',
        instagram: '',
        twitter: '',
        linkedin: '',
      };

      if (!this.formContact) return social;

      const clean = (value) => {
        const raw = String(value || '').trim();
        if (!raw) return '';
        return raw
          .replace(/^https?:\/\/(www\.)?/i, '')
          .replace(/\/+$/, '')
          .replace(/^facebook\.com\//i, '')
          .replace(/^instagram\.com\//i, '')
          .replace(/^twitter\.com\//i, '')
          .replace(/^x\.com\//i, '')
          .replace(/^linkedin\.com\/in\//i, '')
          .replace(/^@/i, '');
      };

      social.facebook = clean(this.formContact.facebook);
      social.instagram = clean(this.formContact.instagram);
      social.twitter = clean(this.formContact.twitter);
      social.linkedin = clean(this.formContact.linkedin);

      return social;
    },
  },
  watch: {
    'contactObj.id': {
      handler(newId, oldId) {
        if (newId && newId != null) {
          console.log('Contact ID changed:', newId);
          this.loadContactData(newId);
        }
      },
      immediate: true,
    },
  },
  methods: {
    async loadContactData(contactId) {
      if (this.isLoading) return;
      try {
        this.isLoading = true;
        await this.getContact(contactId);
      } catch (error) {
        console.error('Erro ao carregar contato:', error);
      } finally {
        this.isLoading = false;
      }
    },
    saveContactMixin() {
      console.log('saveContactMixin');
      this.saveContact();
      this.edit();
    },
    edit() {
      this.$store.commit('contact/toggleEditingContact');
    },
    goToSend(name, contact) {
      if (this.tabLink === 'contacts') {
        if (contact) {
          this.selectedContacts.push(contact);
          this.$router.push({
            name,
            params: { contacts: this.selectedContacts },
          });
        } else {
          this.$router.push({
            name,
            params: { contacts: this.selectedContacts },
          });
        }
      } else {
        this.$router.push({
          name,
          params: { groups: this.selectedGroups },
        });
      }
    },
    escapeHtml(text) {
      const str = String(text ?? '');
      return str
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;')
        .replace(/'/g, '&#039;');
    },

    normalizeUrl(url) {
      const raw = String(url ?? '').trim();
      if (!raw) return '';
      // Se a pessoa digitar "www.site.com" sem https
      if (/^https?:\/\//i.test(raw)) return raw;
      return `https://${raw}`;
    },

    linkify(text) {
      // 1) escapa tudo (evita XSS)
      const safe = this.escapeHtml(text);

      // 2) transforma URLs em <a>
      // Captura http/https e também www.
      const urlRegex = /((https?:\/\/[^\s<]+)|(www\.[^\s<]+))/gi;

      return safe.replace(urlRegex, (match) => {
        const href = /^https?:\/\//i.test(match) ? match : `https://${match}`;
        return `<a href="${href}" target="_blank" rel="noopener noreferrer">${match}</a>`;
      }).replace(/\n/g, '<br/>'); // mantém quebras de linha do textarea
    },
    initials(firstname, lastname) {
      firstname === null ? (firstname = '') : firstname; // Avoiding displaying 'null' string
      lastname === null ? (lastname = '') : lastname; // Avoiding displaying 'null' string
      const emojiRegex = /\p{Emoji}/u;
      // console.log('Firstname: ', firstname, '\nLastname: ', lastname);
      let fullname = '';
      if (firstname) {
        firstname = !firstname.match(emojiRegex)
          ? firstname.charAt(0).toUpperCase()
          : firstname.replace(emojiRegex, '').charAt(0).toUpperCase();
      }
      if (lastname) {
        lastname = !lastname.match(emojiRegex)
          ? lastname.charAt(0).toUpperCase()
          : lastname.replace(emojiRegex, '').charAt(0).toUpperCase();
      }
      fullname = firstname + lastname;
      /* if (firstname && lastname) {
        console.log('Firstname: ', firstname, '\nLastname: ', lastname, '\nMatch: ', lastname.match(emojiRegex));
        fullname = (!firstname.match(emojiRegex) ? firstname.charAt(0).toUpperCase() : firstname.replace(emojiRegex, '').charAt(0)) + (!lastname.match(emojiRegex) ? lastname.charAt(0).toUpperCase() : lastname.replace(emojiRegex, '').charAt(0));
      } */
      // const fullname = firstname.charAt(0) + lastname;
      // fullname = fullname.split(/(?<!\pL|\pN)\pL+(?!\pL|\pN)/g);

      /* if (firstname) {
        firstname = firstname.substring(0, 1).toUpperCase();
      } else {
        firstname = '-';
      }

      if (lastname) {
        lastname = lastname.substring(0, 1).toUpperCase();
      } else if (!firstname) {
        lastname = '';
      } */

      return fullname;
    },
  },
};
</script>

<style lang="scss">
.edit {
  background: transparent;
  border: none;
  padding: 0.1rem;
  font-size: 1.3rem;
  color: var(--gray-font-color-2);
}

.details {

  // height: calc(100% - 155px);
  .save .d-flex {
    gap: 40px;
  }

  label {
    padding: 12px 0;
    display: block;

    span {
      display: block;
      margin-bottom: 10px;
    }
  }

  .scrollbar-data {
    position: relative;
    overflow: hidden;
    height: 100%;
  }

  h5 {
    font-size: 1rem;
    font-weight: normal;
    display: flex;
    align-items: center;
    color: #595959;

    .material-symbols-outlined,
    .fill-icon {
      margin-right: 0.25rem;
      color: var(--gray-font-color-2);
    }
  }

  ul {
    min-height: 65%;
    list-style-type: none;
    padding: 0;
    margin: 0;

    li {
      margin: 0;
      padding: 0.62rem 0;

      &::after {
        clear: both;
        content: "";
        height: 1px;
        display: block;
      }

      .icn {
        float: left;
        width: 32px;
      }

      .material-icons-outlined,
      .material-symbols-outlined {
        color: #752de6;
        font-size: 1.4rem;
        vertical-align: middle;
        margin-right: 0.5rem;
      }

      figure {
        display: inline-block;
        height: 24px;
        width: 24px;
        border-radius: 12px;
        overflow: hidden;
      }
    }
  }

  .custom-field-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .field-title {
      color: var(--foreground);
      font-weight: 400;
    }

    button {
      margin-left: auto;
    }

    label {
      width: 100% !important;
    }

    .custom-field-suggestion {
      width: 100%;

      &:hover {
        label {
          opacity: 0.4;
        }
      }

      label {
        transition: 0.5s;
        opacity: 0.4;

        &:hover,
        &.active {
          opacity: 1;
        }
      }
    }

    .custom-field-suggestion label {
      transition: 0.5s;
      opacity: 0.4;
    }

    .custom-field-suggestion label.filled {
      opacity: 1;
    }

    /* .custom-field-suggestion input:focus {
      // border-color: blue;
      // opacity: 1;
    } */
  }
}

.contact-info {
  .channels {
    margin-bottom: 2rem;

    ul {
      display: flex;
      gap: 2.5rem;
      justify-content: center;
    }
  }
}

.new-contacts-details {
  // position: fixed;
  // z-index: 110;
  // right: 0;
  // top: 0;
  // max-width: 530px;
  // width: 100%;
  // height: 100vh;

  // & > .backdrop {
  //   background: rgba(0, 0, 0, .5);
  //   position: fixed;
  //   z-index: -1;
  //   left: 0;
  //   top: 0;
  //   height: 100%;
  //   width: 100%;
  // }

  .close {
    font-size: 1.5rem;
    position: absolute;
    right: 24px;
    top: 24px;
  }

  &>.card {
    height: 100%;
  }

  .contents {
    // padding: 40px;
    // padding-left: 2rem;
    // padding-right: 2rem;
    padding-top: 2rem;
    height: 100%;

    figure {
      background: #ccc;
      border-radius: 48px;
      height: 84px;
      width: 84px;
      margin: 0 auto;
    }

    h4 {
      margin: 1.2rem 0;
      text-transform: uppercase;
      text-align: center;
      font-size: 0.72rem;
    }

    .humor {
      border-bottom: thin solid #dfdfdf;
      text-align: center;
      padding: 20px 0;

      .note {
        margin: 0 auto;
        width: 120px;

        div {
          padding-left: 0.8rem;
          font-size: 2.5rem;
          font-weight: 500;
          line-height: 1;
        }
      }

      p {
        padding-top: 20px;
      }
    }

    h5 {
      padding-bottom: 24px;
      margin: 0;
      font-family: Poppins;
      font-size: 16px;
      font-style: normal;
      font-weight: 400;
      line-height: 30px;
    }

    .extra-info {
      &>.item {
        font-family: Poppins;
        font-size: 14px;
        font-style: normal;
        font-weight: 400;
        line-height: 23px;
        display: inline-flex;
        align-items: center;
        gap: 46px;
      }
    }

    .description {
      padding: 24px 0;

      div {
        min-height: 100px;

        &.nodata {
          color: #dfdfdf;
        }
      }
    }

    .details {
      height: calc(100% - 155px);

      .save .d-flex {
        gap: 40px;
      }

      /* input:valid {
        background-color: #6EDA2C1A;
      } */

      /* input:invalid {
        background-color: #F6293414;
      } */

      label {
        padding: 12px 0;
        display: block;

        span {
          display: block;
          margin-bottom: 10px;
        }
      }

      .scrollbar-data {
        position: relative;
        overflow: hidden;
        height: 100%;
      }

      h5 {
        font-size: 1rem;
        font-weight: normal;
        display: flex;
        align-items: center;
        color: #595959;

        .material-symbols-outlined,
        .fill-icon {
          margin-right: 0.25rem;
          color: var(--gray-font-color-2);
        }
      }

      ul {
        min-height: 65%;
        list-style-type: none;
        padding: 0;
        margin: 0;

        li {
          margin: 0;
          padding: 0.62rem 0;

          &::after {
            clear: both;
            content: "";
            height: 1px;
            display: block;
          }

          .icn {
            float: left;
            width: 32px;
          }

          .material-icons-outlined,
          .material-symbols-outlined {
            color: #752de6;
            font-size: 1.4rem;
            vertical-align: middle;
            margin-right: 0.5rem;
          }

          figure {
            display: inline-block;
            height: 24px;
            width: 24px;
            border-radius: 12px;
            overflow: hidden;
          }
        }
      }
    }
  }
}

.new-group-contacts {
  position: relative;
  padding: 80px 0;
}

.icon_btn:hover {
  background-color: #6018d3 !important;
}

.icon_btn-clean {
  background-color: transparent;
  color: black;
  border: 1px solid rgb(184, 184, 184);
}

.icon_btn-clean:hover {
  background-color: rgb(236, 236, 236);
  color: black;
  border: 1px solid rgb(184, 184, 184);
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
}

.spinner-color {
  color: #b690f1;
  width: 2rem;
  height: 2rem;
  border-width: 3px;
}

@media (max-width: 767.98px) {
  .new-group-contacts {
    padding: 0;
    margin-top: 5rem;
    margin-bottom: 5rem;
  }
}

.new-contacts-search {
  margin: 2rem 0 4rem 0;

  .text-field {
    position: relative;
    margin: 0 auto;
    max-width: 952px;
    background: #fff;
    border: thin solid #ccc;
    border-radius: 0.2rem;
    width: 100%;

    input {
      background: transparent;
      padding-left: 2rem;
      padding-right: 2rem;
      width: 100%;
      height: 48px;
      border: none;
    }

    .material-icons-outlined {
      position: absolute;
      right: 8px;
      top: 8px;
      font-size: 2rem;
      pointer-events: none;
    }
  }
}

.new-contacts {
  .card {
    box-shadow: none !important;
    border: thin solid #dfdfdf;
    border-radius: 0.2rem;
  }

  .all-actions {
    padding-bottom: 4rem;

    .extra {
      margin-left: 5px;
      width: 42px;
      height: 42px;
      display: flex;
      align-items: center;
      justify-content: center;

      span.material-symbols-outlined {
        color: var(--gray-font-color);
      }

      button {
        padding: 0 !important;
      }

      img {
        max-width: 25px;
        width: 28px;

        &.last {
          width: 20px;
        }
      }
    }
  }

  .action {
    padding: 0.5rem;
    padding-left: 0;

    *,
    button {
      font-weight: normal !important;
      color: #697077 !important;
    }

    button {
      background: transparent;
      border: none;
    }

    .control-group,
    .material-symbols-outlined {
      margin-right: 0.5rem;
    }
  }

  header {
    height: 2rem;
  }

  .profile-item {
    padding-bottom: 2rem !important;
    cursor: pointer;
    position: relative;
    z-index: 0;

    &:hover {
      z-index: 10 !important;

      &~.profile-item {
        z-index: 1 !important;
      }

      .profile-socials button {
        margin-left: 5px;
      }
    }
  }

  .profile-data {
    border: none;
    background: transparent;
    text-align: left;
    position: relative;
    z-index: 10;

    &:focus {
      outline: unset !important;
    }
  }

  .profile-more-details * {
    transition: 0.5s ease-in-out;
  }

  .profile-more-details {
    position: absolute;
    z-index: -100;
    width: 250px;
    height: 94px;
    color: #5a5a5a;
    opacity: 0;
    border-radius: 8px;
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.1) !important;

    .detail-info {
      .col-6 {
        display: flex;
        align-items: center;
        gap: 0.25rem;
      }
    }

    .send-message {
      text-align: center;
      font-size: 0.92rem;

      &,
      ::v-deep a {
        color: #000;
      }
    }

    figure {
      background: #752de6;
      // height: 268px;
      height: 0;
    }

    figure~div,
    figure~div * {
      height: 0;
    }

    .acts {
      button {
        border: none;
        background: transparent;
        padding: 5px;
        margin: 0 10px;
        font-size: 1.5rem;

        img {
          width: 20px;
        }
      }
    }
  }

  .profile-photo {
    width: 115px;
    margin: 0 auto;

    figure {
      margin: 0 auto;
      border-radius: 48px;
      background: #752de6;
      width: 92px;
      height: 92px;
    }

    &:hover {
      color: #fc0;

      &~.profile-more-details {
        opacity: 1;
        z-index: 100;
      }
    }
  }

  .profile-more-details:hover {
    opacity: 1;
    z-index: 100;
    height: auto;
  }

  .profile-more-details:hover figure {
    height: 200px;
  }

  .profile-more-details:hover figure~div,
  .profile-more-details:hover figure~div * {
    height: auto;
    z-index: 200;
  }

  .profile-meta {
    position: relative;

    h3 {
      color: #752de6;
      font-size: 0.82rem;
      text-transform: uppercase;
    }

    ul {
      list-style-type: none;

      &,
      li {
        margin: 0;
        padding: 0;
      }

      li {
        padding: 0.12rem 0;
        color: #697077;

        span {
          font-size: 1.32rem;
          font-weight: 100;
          vertical-align: middle;
        }
      }
    }
  }

  .profile-socials {
    position: absolute;
    z-index: 1;
    bottom: 1rem;
    right: 1rem;

    button {
      position: relative;
      z-index: 10;
      box-shadow: 0 0 0 0.2rem #fff;
      // background: #fc0;
      border-radius: 13px;
      height: 26px;
      width: 26px;
      border: none;
      margin-left: -5px;
      font-size: 0;
      overflow: hidden;
      transition: 0.2s ease-out;

      &:focus {
        outline: unset !important;
      }

      img {
        transform: scale(1.5);
      }
    }

    button+button {
      z-index: 9;
    }

    button+button+button {
      z-index: 8;
    }

    button+button+button+button {
      z-index: 7;
    }

    button+button+button+button+button {
      z-index: 6;
    }

    button+button+button+button+button+button {
      z-index: 5;
    }
  }

  .more {
    button {
      background: transparent;
      border: none;
    }

    a {
      color: var(--gray-font-color-4);
    }

    span {
      color: var(--gray-font-color-4);
      font-size: 3rem;
      line-height: 0.5;

      &.material-symbols-outlined.thin-icon {
        font-size: 1.5rem;
        margin-right: 0.5rem;
      }
    }
  }
}

.custom-control-label {

  &::after,
  &::before {
    top: -0.5rem;
  }
}

.btn i {
  line-height: 1;
  color: inherit;
}

.btn {
  margin-bottom: 5px;
}

.btn-search {
  margin-left: 8px;
}

.card-contacts {
  margin: 18px;
}

.card-contacts-list-item {
  padding: 20px;
}

.card-contacts-list-avatar {
  background: #c02fdf;
  width: 65px;
  height: 65px;
  border-radius: 55px;
  text-align: center;
  vertical-align: middle;
  margin: 0 auto;
}

.card-contacts-list-avatar span {
  font-size: 25px;
  color: white;
  display: block;
  padding-top: 15px;
}

.card-contacts-list-item h3 {
  color: #752de6;
  font-size: 14px;
}

.card-contacts-list-item h2 {
  color: #9ca7b0;
  font-size: 14px;
}

.card-contacts-list-item-body span {
  color: #9ca7b0;
  font-size: 13px;
  display: block;
  margin-top: 5px;
  font-weight: 300;
}

.card-contacts-list-item-body-info {
  font-size: 13px;
  color: #9ca7b0;
  margin-top: 10px;
}

.btn-collapse {
  background: none !important;
  padding: 0px !important;
  border: none !important;
  color: #9ca7b0 !important;
  font-weight: 500 !important;
  height: 0 !important;
}

.btn-collapse:hover {
  background: none !important;
  padding: 0px !important;
  border: none !important;
  color: #8e9397 !important;
  font-weight: 500 !important;
  box-shadow: none !important;
}

.refresh-date-item {
  color: #9ca7b0;
  font-size: 10px;
}

.list-item-info-collapse {
  color: #9ca7b0;
  font-size: 14px;
  margin-top: 20px;
}

.list-item-info-collapse span {
  display: block;
}

.btn-edit-contact {
  position: absolute;
  right: 10px;
  top: 15px;
  cursor: pointer;
  z-index: 2;
}

.btn-edit-contact img {
  cursor: pointer !important;
}

.btn-edit-contact .dropdown {
  cursor: pointer !important;
}

.input-container {
  float: right;
  position: relative;
  width: 40%;
  margin-left: 10px;
}

.input-container img {
  position: absolute;
  right: 0;
  top: 0;
  width: 20px;
  margin-top: 10px;
  margin-right: 8px;
  cursor: pointer;
}

.to-right {
  float: right !important;
}

.btns-right-container {
  width: 55%;
  float: right;
  margin-top: 10px;
}

.btns-right-container span {
  width: 50px;
  height: 50px;
  padding: 10px;
  margin-left: 10px;
}

.btns-right-container a {
  width: 50px;
  height: 50px;
  padding: 10px;
}

.btns-right-container a:hover {
  background: rgb(238, 238, 238);
  border-radius: 10px;
  cursor: pointer;
}

.btns-right-container span:hover {
  background: rgb(238, 238, 238);
  border-radius: 10px;
  cursor: pointer;
}

.btns-right-container .span-first {
  background: #752de6;
  border-radius: 10px;
}

.to-left {
  float: left !important;
}

.icon-contact {
  font-size: 18px !important;
  margin-right: 5px !important;
  margin-top: 6px !important;
}

.tab-container-tags-item i {
  color: #752de6;
}

.tab-container-tags-item {
  float: left;
  border: 1px solid transparent;
  color: #752de6;
  font-size: 16px;
  /* padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px; */
  // border-radius: 20px;
  // margin-right: 10px;
  cursor: pointer;
}

.tab-container-tags-item-settings i {
  color: #d5273e;
}

.tab-container-tags-item-settings {
  float: left;
  color: #d5273e;
  font-size: 16px;
  padding-left: 15px;
  padding-right: 15px;
  padding-top: 5px;
  padding-bottom: 5px;
  border-radius: 20px;
  margin-right: 10px;
  cursor: pointer;
}

@media (max-width: 767.98px) {
  ::v-deep {
    .all-actions {
      flex-wrap: wrap;
    }

    .action~.flex-grow-1 {
      width: 100%;
    }

    .create-contact {
      /* width: 100%; */
      order: 2;
      margin-top: 10px;
    }
  }

  .text-wrapper {
    display: flex;
    align-items: center;
  }

  .tab-container-tags-item-settings {
    position: absolute;
    top: 0;
    right: 0;
  }

  .tab-container-item-display {
    flex: 1 0 45%;
    margin: auto;

    /* .tab-container-tags-item {
      padding: 0;
    } */
  }

  .tags-item-active {
    margin-left: unset;
  }

  .tab-container-tags-item {
    margin-right: unset;
    padding: 5px;

    /* & > div {
      padding: 0;
    } */
    .material-symbols-outlined {
      margin-right: 10px;
    }
  }
}

.tags-item-active {
  span {
    background: #752de6;
    color: #fff;
  }
}

.tags-item-active i {
  color: #fff;
}

.tab-group-container-tags {
  margin-left: 20px;
  margin-bottom: 40px;
}

.dropdown-menu-contact ul {
  min-width: 50px !important;
  width: 50px !important;
}

.rebranding .card .opts_card {
  display: flex;
  align-items: center;
  margin-left: auto;
  gap: 25px;
}

.btns-right-container {
  margin: 0px;
  max-width: 500px;
  text-align: right !important;
  display: block !important;
}

.tab-container-item-display {
  // min-width: 110px;
  float: left;
}

.tab-container-tags-item {
  transition: margin-left 0.2s;
}

.tags-item-active {
  margin-left: 3px;
}

.check-box-contact {
  position: absolute;
  top: 10px;
  left: 30px;
  z-index: 1;
}

.all-check-box {
  margin-left: 20px;
}

.check-info {
  margin-right: 20px;
  display: block;
}

.check-all-info {
  color: #9ca7b0;
}

.c-pointer {
  cursor: pointer !important;
}

.dropdown-menu-right {
  top: 40px !important;
}

@media (max-width: 767.98px) {
  ::v-deep .tab-container-tags {
    display: flex;
    gap: 1rem;
    flex-wrap: wrap;
  }
}

.btn-tags {
  border: 1px solid var(--gray-font-color-3);
  border-radius: 25px;
  font-weight: 400;
  color: var(--gray-font-color-2);
}

/* Tags wrapper */
.tags-wrapper {
  position: relative;
  padding: 0.5rem 10px 0.5rem 35px;
  overflow-x: hidden;
  max-width: 100%;
  width: 100%;
  background-color: var(--background);
  border-radius: 13px;
  margin-left: -30px;

  .icon {
    position: absolute;
    top: 0;
    height: 100%;
    width: 120px;
    display: flex;
    align-items: center;

    .material-symbols-outlined {
      width: 40px;
      height: 40px;
      cursor: pointer;
      font-size: 1.2rem;
      text-align: center;
      line-height: 40px;
      border-radius: 50%;
      background-color: var(--background);
      border: 1px solid var(--gray-font-color-3);

      &:hover {
        background: #efedfb;
      }
    }

    &:first-child {
      left: 0;
      display: none;
      background: linear-gradient(90deg, var(--background) 70%, transparent);

      & .material-symbols-outlined {
        margin-left: 30px;
      }
    }

    &:last-child {
      right: 0;
      // display: none;
      justify-content: flex-end;
      background: linear-gradient(-90deg, var(--background) 70%, transparent);

      & .material-symbols-outlined {
        margin-right: 15px;
      }
    }
  }

  .tabs-box {
    display: flex;
    gap: 12px;
    list-style: none;
    margin-bottom: 0;
    overflow-x: hidden;
    scroll-behavior: smooth;
    padding-left: 0;

    /* .tab:not(.tab:last-child) {
      margin-right: 12px;
    } */

    &.dragging {
      scroll-behavior: auto;
      cursor: grab;

      & .tab {
        user-select: none;
        pointer-events: none;
      }
    }
  }

  .tab {
    cursor: pointer;
    font-size: 1.1rem;
    white-space: nowrap;
    background: var(--background);
    border-radius: 30px;
    border: 1px solid var(--gray-font-color-3);
    padding: 5px 12px;

    &.active {
      background-color: var(--clr-yup-purple);
      color: #fff;
      border-color: transparent;
    }
  }
}

.opt-tags {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  .btn-settings {
    width: fit-content;
    cursor: pointer;
    font-size: 1.1rem;
    white-space: nowrap;
    background: var(--background);
    // border-radius: 30px;
    // border: 1px solid var(--gray-font-color-3);
    padding: 5px 12px;
    margin-left: auto;

    a {
      display: flex;
      color: var(--gray-font-color-4);
    }
  }
}

::v-deep {
  .btn {
    border-radius: 8px;
  }

  ul.pagination {
    padding-right: 3rem !important;
  }

  .custom-field-wrapper {
    display: flex;
    align-items: center;
    flex-wrap: wrap;

    .field-title {
      color: var(--foreground);
      font-weight: 400;
    }

    button {
      margin-left: auto;
    }

    label {
      width: 100% !important;
    }

    .custom-field-suggestion {
      width: 100%;

      &:hover {
        label {
          opacity: 0.4;
        }
      }

      label {
        transition: 0.5s;
        opacity: 0.4;

        &:hover,
        &.active {
          opacity: 1;
        }
      }
    }

    .custom-field-suggestion label {
      transition: 0.5s;
      opacity: 0.4;
    }

    .custom-field-suggestion label.filled {
      opacity: 1;
    }

    /* .custom-field-suggestion input:focus {
      // border-color: blue;
      // opacity: 1;
    } */
  }

  .btn-add-card:not(.col-task-grid .btn-add-card) {
    color: var(--clr-yup-purple);
    // text-decoration: underline;
    font-size: 1rem;
    font-weight: 400;
  }

  .btn-add-col,
  .col-task-grid .btn-add-card {
    background-color: #6b23dc14;
    border-color: #e5e5e5;
    color: var(--clr-yup-purple);
    font-weight: 400;
    border-radius: 8px;

    &:hover,
    &:focus {
      background-color: #6b23dc5e;
      color: #772ced;
    }
  }
}

/* Sidebar add prod */
::v-deep .b-sidebar {
  background-color: var(--background-2) !important;
  width: 525px;

  small {
    color: var(--gray-font-color);
  }

  .edit {
    background: transparent;
    border: none;
    padding: 0.1rem;
    font-size: 1.3rem;
    color: var(--gray-font-color-2);
  }

  .sidebar-header {
    display: flex;
    align-items: center;
    padding-top: 2rem;
    margin-bottom: 2rem;

    .sidebar-title {
      color: var(--foreground);
      font-size: 1.25rem;
    }

    .sidebar-close {
      position: absolute;
      top: 10px;
      right: 10px;
    }

    p {
      display: block;
      font-size: 1rem;
      margin-bottom: 1px;
    }

    p,
    span.material-symbols-outlined {
      color: var(--gray-font-color-2);
    }
  }

  .title-column {
    margin-bottom: 2rem;

    .title-task {
      display: flex;
      align-items: center;
      margin-bottom: 0.5rem;

      * {
        font-size: 1.625rem;
      }

      .not-editing {
        margin-right: 1rem;
      }
    }
  }

  .responsable-column {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    gap: 0.5rem;
    margin-bottom: 2.5rem;

    p {
      font-size: 1rem;
      margin-right: 0.5rem;
      margin-bottom: 0;
    }

    .material-symbols-outlined {
      color: var(--gray-font-color);
    }

    img {
      border-radius: 50%;
      width: 40px;
      height: 40px;

      &:last-of-type {
        margin-right: 0.5rem;
      }
    }
  }

  .description-column {
    >p {
      font-size: 1rem;
      margin-bottom: 0.5rem;
    }

    & p:last-of-type {
      font-size: 0.875rem;
      color: var(--gray-font-color);
    }

    /* textarea {
      margin-bottom: 1px;
    } */
  }

  .btn-wrapper {
    display: flex;
    align-items: center;
  }

  .b-sidebar-body {
    padding-left: 1rem;
    padding-right: 1rem;
    padding-bottom: 1.5rem;
  }

  header {
    >strong {
      order: -1;
    }
  }

  .title-column {
    p {
      color: var(--gray-font-color);
    }
  }

  textarea,
  select,
  .form-control {
    border-radius: 8px;
  }

  .input-group>.form-control:not(:last-child) {
    border-top-right-radius: 0 !important;
    border-bottom-right-radius: 0 !important;
  }

  .input-group-prepend:not(:first-child)>.btn {
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
  }

  .create-custom-field {
    display: flex;
    flex-wrap: wrap;

    button {
      border-radius: 8px;
      width: fit-content;
    }

    .input-group {
      display: flex;
      margin-bottom: 1.5rem;

      label {
        display: flex;
        align-items: center;
        gap: 0.5rem;
      }

      label:not(label.control) {
        width: 100%;
      }

      label.control~span {
        font-weight: 400;
        font-size: 0.875rem !important;
        margin-left: 0.5rem;
        color: var(--gray-font-color-6);
      }
    }

    .material-symbols-outlined {
      color: var(--gray-font-color);
    }

    /* .title-group {
      font-weight: 400;
      color: var(--gray-font-color-6);
      margin-bottom: 1rem;
    } */
    /* .custom-field-list {
      width: 100%;
      li {
        margin-bottom: .5rem;
        color: var(--gray-font-color-2);
        font-weight: 400;
      }
    } */
  }
}

/* Search form style */
.form-group {
  label {
    color: var(--foreground);
    font-size: 16px;
    margin-bottom: 20px;
  }

  input:-ms-input-placeholder {
    text-transform: lowercase !important;
  }

  input::-webkit-input-placeholder {
    text-transform: lowercase !important;
  }

  input::placeholder {
    text-transform: lowercase !important;
  }

  #inputPassword {
    border-right-color: transparent;
    border-right-width: 0;
  }

  .btn-space {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2rem 0 2rem 0 !important;
  }

  .icon_btn {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    color: white;
    padding: 0.5rem 0.8rem !important;
    background-color: var(--clr-yup-purple);
    border: 1px solid var(--clr-yup-purple);
    border-radius: 0.5rem;
    font-size: 16px;

    .icon-search {
      font-size: 20px !important;
      color: rgb(248, 248, 248) !important;
    }
  }
}

.darkmode .form-group .icon_btn {
  background-color: var(--form-input);
  border-color: var(--form-border);
}

.form-wrapper {
  flex: 1 0 20%;

  .form-group {
    height: 55px;
  }

  .form-control,
  .input-group-prepend,
  .input-group,
  .icon_btn {
    height: 100%;

    span {
      color: var(--gray-font-color-5);
      font-size: 38px;
    }
  }
}

@media (min-width: 1660px) {
  .form-wrapper {
    min-width: 0;
    max-width: 100%;
    position: relative;
    width: 100%;
    padding-right: 15px;
    padding-left: 15px;
    flex-basis: 0;
    flex-grow: 1;
  }
}

@media (max-width: 767.98px) {
  .form-wrapper {
    flex: 1 0 40%;
  }
}

.btn-delete-all {
  font-size: 14px;
  color: #595959;
}

.btn-delete-all .material-symbols-outlined {
  font-size: 20px;
}

.send-campaign {
  width: auto !important;
  font-size: 14px;
  color: #595959;
  font-weight: normal !important;
  margin-left: 15px !important;
}

.send-campaign .dropdown {
  margin-right: 10px;
}

.btn-add {
  display: flex;
}

.btn-add span {
  color: #6b23dc;
  font-size: 16px !important;
  cursor: pointer;
  display: block;
  font-weight: normal !important;
}

.btn-add .material-symbols-outlined {
  margin-top: 4px;
  margin-left: 5px;
}

.create-contact {
  padding-top: 10px;
}

.new-contacts .all-actions .extra img.last {
  width: 15px;
}

.card.card-tabs .card-header .nav.nav-tabs {
  width: 100%;
  padding: 0 1rem;
  gap: 2.5rem;
}

.card.card-tabs .card-header .nav.nav-tabs li a {
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 1.4rem 0.7rem 1.3rem;
  color: var(--clr-light-2);
}

.nav.nav-tabs .nav-item .nav-link.router-link-exact-active {
  color: var(--clr-yup-purple) !important;
  border-bottom: solid 2px var(--clr-yup-purple);
}

.nav.nav-tabs .nav-item .nav-link.router-link-exact-active i {
  color: var(--clr-yup-purple) !important;
}

.card.card-tabs .card-header .nav.nav-tabs li a i {
  font-size: 24px;
}

.nav-tabs .nav-item {
  margin-bottom: -2px;
}

.nav-tabs {
  border-bottom: 2px solid rgba(210, 221, 234, 0.5);
}

.rebranding .card .opts_card i {
  font-size: 22px;
  transition: 0.5s;
  padding: 5px;
}

.rebranding .card .opts_card i:hover {
  background-color: var(--background-icon-hover);
  border-radius: 5px;
}

.rebranding .card {
  box-shadow: none;
}

.card.card-tabs .card-header .nav.nav-tabs {
  width: 100%;
  padding: 0 1rem;
  gap: 2.5rem;
}

.card.card-tabs .card-header .nav.nav-tabs {
  margin-bottom: 5px;
}

.nav-tabs {
  border-bottom: 4px solid #6b23dc3d;
}

.nav.nav-tabs .nav-item .nav-link.router-link-exact-active {
  border-bottom: solid 4px var(--clr-yup-purple);
}

.nav-tabs .nav-item {
  margin-bottom: -4px;
}

.thin-icon *,
.thin-icon {
  font-variation-settings: "FILL" 0, "wght" 400, "GRAD" 0, "opsz" 48;
}

.content-row {
  width: 100%;
  display: flex;
  background-color: var(--background-2);
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 2.5rem;
  padding-left: 0;
  padding-right: 0;

  >div {
    display: flex;
    align-items: center;
    min-height: 52px;
  }

  /* @media (min-width: 768px) {
    div:last-child {
      justify-content: center;
    }
  } */
}

.option-wrapper {
  margin-left: auto;

  .btn {
    padding: 0;
    height: auto;
    color: var(--gray-font-color-4);

    &:first-of-type {
      margin-right: 0.5rem;
    }
  }
}

.text-item {
  margin-left: 0.5rem;
  margin-bottom: 0;
}

.span-contact {
  background: #fcf2e6;
  padding: 1px 8px 1px 8px;
  border-radius: 4px;
  color: #aa5b00;
  font-size: 12px;
}

.right-slide-down {
  margin-left: 10px;
  margin-top: 10px;
}

.expand-icon {
  font-size: 13px;
  position: absolute;
  left: 10px;
  top: 10px;
  color: #595959;
  font-weight: 400;
  cursor: pointer;
}

.expand-icon .material-icons-outlined {
  font-size: 30px;
  float: left;
  margin-top: -4px;
}

.img-preview {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: solid 3px var(--clr-yup-purple);
  background-position: top !important;
  background-size: cover !important;
  margin: 0 auto;
}

.img-preview-large {
  height: 150px;
  width: 100%;
  background-position: top !important;
  background-size: cover !important;
  margin: 0 auto;
}

.table-placeholder {
  width: 100%;
  margin-top: 10px;
  margin-bottom: 25px;
}

.input-group input::placeholder {
  text-transform: none !important;
}

.fallback-image {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 2.2rem;
  color: #fff;
}

.expand-icon {
  font-size: 13px;
  position: absolute;
  left: 10px;
  top: 10px;
  color: #595959;
  font-weight: 400;
  cursor: pointer;
}

.expand-icon .material-icons-outlined {
  font-size: 30px;
  float: left;
  margin-top: -4px;
}

.img-preview {
  width: 80px;
  height: 80px;
  border-radius: 50%;
  border: solid 3px var(--clr-yup-purple);
  background-position: top !important;
  background-size: cover !important;
  margin: 0 auto;
}

.img-preview-large {
  height: 150px;
  width: 100%;
  background-position: top !important;
  background-size: cover !important;
  margin: 0 auto;
}
</style>
